import { SagaIterator } from 'redux-saga';
import { takeEvery, takeLatest } from 'redux-saga/effects';

import {
  DeletePublishedConnectionDraft,
  EditPublishedConnection, EditPublishedConnectionDraft,
  EnterPublishedConnectionSubspace,
  PublishedConnectionCountsRequest
} from '~src/bootstrap/redux/actions/AppActionTypes';
import {
  handleDeletePublishedConnectionDraft
} from '~src/publishedConnection/sagas/DeletePublishedConnectionDraftSaga';
import { handleEditPublishedConnectionDraft } from '~src/publishedConnection/sagas/EditPublishedConnectionDraftSaga';

import { handleEditPublishedConnection } from './EditPublishedConnectionSaga';
import { handleEnterPublishedConnectionSubspace } from './EnterPublishedConnectionSpaceSaga';
import { handlePublishedConnectionCountsRequest } from './PublishedConnectionCountsRequestSaga';

export function* rootPublishedConnectionSaga(): SagaIterator {
  yield takeEvery(EditPublishedConnection, handleEditPublishedConnection);
  yield takeEvery(EditPublishedConnectionDraft, handleEditPublishedConnectionDraft);
  yield takeEvery(DeletePublishedConnectionDraft, handleDeletePublishedConnectionDraft);
  yield takeLatest(EnterPublishedConnectionSubspace, handleEnterPublishedConnectionSubspace);
  yield takeLatest(PublishedConnectionCountsRequest, handlePublishedConnectionCountsRequest);
}
